import { Box } from '@mui/material';

import { ProductInformationRow } from './ProductInformationRow';
import { ReactNode } from 'react';

interface Props {
  rows: { name: string; value: string | number | undefined | ReactNode }[];
  gridColumns: string;
}

export const ProductInformationRows = ({ rows, gridColumns }: Props) => {
  return (
    <Box>
      {rows.map((row) => (
        <ProductInformationRow
          key={row.name}
          name={row.name}
          value={row.value}
          gridColumns={gridColumns}
        />
      ))}
    </Box>
  );
};
